//Resizes alignwide and alignfull images

jQuery(document).ready(function($) {

	const wide_width_images = $('.alignwide');
	const full_width_images = $('.alignfull');

	if(wide_width_images.length) {
		adjustAlignWideWidth();
	}

	if (full_width_images.length) {
		adjustAlignFullWidth();
	}

	function adjustAlignFullWidth() {
		const page_width = $(window).width();
		full_width_images.css({width: page_width}).offset({left: 0});
	}

	function adjustAlignWideWidth() {
		const section_width = $('section.content').width();
		const offset = $('section.content').css('padding-left');
		wide_width_images.css({width: section_width}).offset({left: parseInt(offset)});
	}
 
})